import {applyMiddleware, combineReducers, createStore} from "redux";
import thunk from "redux-thunk";
import middleware from 'redux-when';
import {batchEnhancer, batchMiddleware} from 'redux-batch-enhancer'
import {composeWithDevTools} from 'redux-devtools-extension';

import reducers from "./shared/reducers";
import {rocketChat} from "./shared/modules/rocketChat/middleware/rocketChat";
import {asyncDispatch} from "./shared/middleware/asyncDispatch";

export default createStore(
  combineReducers({...reducers}),
  composeWithDevTools(
    applyMiddleware(
      rocketChat,
      thunk,
      middleware,
      batchMiddleware,
      asyncDispatch
    )
  ),
  batchEnhancer
);
